export default "/_next/static/images/f09adfc0f8110fda1e2448db3595ba18.png";